import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API_BASE from "../config/api";

function Navbar() {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const saved = localStorage.getItem("user");
        if (saved) setUser(JSON.parse(saved));
    }, []);

    const handleLogout = () => {
        console.log("LOGOUT CLICKED");   // 🔥 ADD THIS
        localStorage.removeItem("user");
        window.location.href = "/";       // full reload
    };

    const [show, setShow] = useState(false);
    const [agents, setAgents] = useState([]);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [loading, setLoading] = useState(false);
    const [mobile, setMobile] = useState("");

    useEffect(() => {
        fetchAgents();
    }, []);

    const fetchAgents = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE}/api/support-agents.php`);
            const data = await res.json();
            if (data.success && Array.isArray(data.data)) {
                setAgents(data.data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const openModal = () => {
        if (agents.length > 0) {
            const random =
                agents[Math.floor(Math.random() * agents.length)];
            setSelectedAgent(random);
        }
        setShow(true);
    };

    const closeModal = () => setShow(false);

    return (
        <>
            <nav className="navbar navbar-expand-lg bg-white shadow-sm py-3 sticky-top">
                <div className="container">

                    {/* Logo */}
                    <Link to="/" className="navbar-brand d-flex align-items-center">
                        <img
                            src="/logo.png"
                            alt="Dial Nepal Logo"
                            style={{ width: "160px", marginRight: "49px" }}
                        />
                    </Link>

                    {/* Mobile Toggle */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#mainNavbar"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="mainNavbar">

                        {/* CENTER MENU */}
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0 pl-2">
                            <li className="nav-item px-2">
                                <Link className="nav-link fw-semibold text-dark" style={{ fontSize: "17px" }} to="/">Home</Link>
                            </li>

                            <li className="nav-item px-2">
                                <Link
                                    className="nav-link fw-semibold text-dark position-relative"
                                    style={{ fontSize: "17px" }}
                                    to="/#"
                                >
                                    Leads

                                    {/* 🔴 Red Dot (very close) */}
                                    <span
                                        style={{
                                            width: "7px",
                                            height: "7px",
                                            background: "red",
                                            borderRadius: "50%",
                                            position: "absolute",
                                            top: "5px",
                                            right: "1px"   // ← moved VERY close
                                        }}
                                    ></span>
                                </Link>
                            </li>



                            <li className="nav-item px-2">
                                <Link className="nav-link fw-semibold text-dark" style={{ fontSize: "17px" }} to="/#">Advertise</Link>
                            </li>

                            <li className="nav-item px-2">
                                <Link className="nav-link fw-semibold text-dark" style={{ fontSize: "17px" }} to="/#">Become An Agent</Link>
                            </li>
                        </ul>



                        {/* RIGHT SIDE BUTTONS */}
                        <div className="d-flex align-items-center gap-2 ms-lg-3 mt-3 mt-lg-0">

                            {/* 1️⃣ Free Listing Button */}
                            <Link to="/add-listing" className="fb btn  px-3 d-flex align-items-center" style={{
                                backgroundColor: "#0076d7",   // faint blue
                                color: "#ffffff",             // white text
                                border: "1px solid #6ea8fe"
                            }}>
                                <i className="bi bi-plus-lg me-1"></i>
                                Free Listing

                                {/* 🏷️ Small Tag Badge like JD business name */}
                                <span className="badge bg-warning text-dark ms-2" style={{ fontSize: "10px" }}>
                                    New
                                </span>
                            </Link>


                            {/* BUTTON */}
                            <button
                                className="btn btn-success px-3"
                                onClick={openModal}
                            >
                                <i className="bi bi-telephone-fill me-1"></i>
                                Talk to Us
                            </button>

                            {/* MODAL */}
                            {show && (
                                <div
                                    className="modal fade show"
                                    style={{ display: "block", background: "rgba(0,0,0,.5)" }}
                                >
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content" style={{ borderRadius: 18 }}>
                                            {/* HEADER */}
                                            <div
                                                className="text-white text-center p-3"
                                                style={{
                                                    background: "linear-gradient(135deg,#4C6EF5,#15AABF)",
                                                    borderTopLeftRadius: 18,   // ✅ curve top-left
                                                    borderTopRightRadius: 18,  // ✅ curve top-right
                                                }}
                                            >
                                                <h5 className="mb-0">
                                                    Talk to Our Support Expert
                                                </h5>
                                            </div>

                                            {/* BODY */}
                                            <div className="p-4">
                                                {loading ? (
                                                    <div className="text-center">Loading...</div>
                                                ) : selectedAgent ? (
                                                    <div
                                                        className="d-flex align-items-center p-3 mb-4"
                                                        style={{
                                                            background: "#f6f8ff",
                                                            borderRadius: 14,
                                                        }}
                                                    >
                                                        <img
                                                            src={selectedAgent.photo}
                                                            onError={(e) =>
                                                            (e.target.src =
                                                                "https://images.dialnepal.com.np/default.png")
                                                            }
                                                            className="rounded-circle me-3"
                                                            style={{
                                                                width: 60,
                                                                height: 60,
                                                                objectFit: "cover",
                                                            }}
                                                            alt={selectedAgent.name}
                                                        />
                                                        <div>
                                                            <h6 className="fw-bold mb-1">
                                                                {selectedAgent.name}
                                                            </h6>
                                                            <small className="text-muted">
                                                                Available to assist you
                                                            </small>
                                                        </div>
                                                    </div>
                                                ) : null}

                                                <input
                                                    className="form-control mb-3"
                                                    placeholder="98XXXXXXXX"
                                                    maxLength="10"
                                                    value={mobile}
                                                    onChange={(e) =>
                                                        setMobile(e.target.value)
                                                    }
                                                />

                                                <div className="d-flex justify-content-end gap-2">
                                                    <button
                                                        className="btn btn-light"
                                                        onClick={closeModal}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        className="btn btn-success"
                                                        onClick={() =>
                                                            alert(
                                                                `Request call from ${selectedAgent?.name}`
                                                            )
                                                        }
                                                    >
                                                        Request Call
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}




                            {/* BEFORE LOGIN → Show Login Button */}
                            {!user && (
                                <Link to="/login" className="btn btn-outline-primary px-3">
                                    <i className="bi bi-box-arrow-in-right me-1"></i>
                                    Login
                                </Link>
                            )}

                            {/* AFTER LOGIN */}
                            {user && (
                                <div className="dropdown">
                                    <button
                                        className="user-btn dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                    >
                                        <i className="bi bi-person-circle me-2"></i>
                                        {user.fullname}
                                    </button>

                                    <ul className="dropdown-menu dropdown-menu-end shadow-sm">
                                        <li>
                                            <span className="dropdown-item-text small text-muted">
                                                Welcome
                                            </span>
                                        </li>

                                        <li>
                                            <span className="dropdown-item-text fw-semibold">
                                                {user.fullname}
                                            </span>
                                        </li>

                                        <li><hr className="dropdown-divider" /></li>

                                        <li>
                                            <Link
                                                className="dropdown-item"
                                                to={`/admin?userid=${user.personaluid}`}
                                            >
                                                <i className="bi bi-grid me-2"></i>
                                                Admin Panel
                                            </Link>
                                        </li>

                                        <li>
                                            <button
                                                className="dropdown-item text-danger"
                                                onClick={handleLogout}
                                            >
                                                <i className="bi bi-box-arrow-right me-2"></i>
                                                Logout
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </nav>

            {/* Internal CSS */}
            <style>{`
                .nav-text {
                    font-size: 15px;
                    font-weight: 500;
                    margin-right: 20px;
                }

                .nav-link:hover {
                    color: #0d6efd !important;
                }
            `}</style>
            <style>{`
                .dropdown-menu {
                    border-radius: 8px;
                }

                .dropdown-item:hover {
                    background: #f2f5ff;
                }

                .btn-light {
                    background: #fff;
                    border-radius: 6px;
                }
                    .user-btn {
                    background: transparent !important;
                    border: none !important;
                    outline: none !important;
                    box-shadow: none !important;
                    padding: 6px 12px;
                    display: flex;
                    align-items: center;
                    color: var(--bs-primary) !important;
                    font-weight: 500;
                }

                .user-btn i {
                    color: var(--bs-primary) !important;
                }

                /* Remove grey/blue hover & active effects */
                .user-btn:hover,
                .user-btn:focus,
                .user-btn:active,
                .user-btn.show {
                    background: transparent !important;
                    border: none !important;
                    outline: none !important;
                    box-shadow: none !important;
                    color: var(--bs-primary) !important;
                }
                    /* GLOBAL FONT SETTINGS */
body, .navbar, .nav-link, .dropdown-menu, .btn {
    font-family: "Poppins", sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #000 !important;
}
.fb{

color: #fff !important; }

/* NAV ITEMS SMALL + RIGHT ALIGN */
#mainNavbar .navbar-nav {
    margin-left: auto !important;  /* ← moves all 4 nav items to RIGHT */
    margin-right: 0 !important;
}

/* Reduce gap between items slightly */
#mainNavbar .nav-item {
    padding-left: 6px !important;   /* reduced from px-2 */
    padding-right: 6px !important;
}

/* BUTTONS SMALL LIKE JustDial */
.navbar .btn {
    padding: 4px 10px !important;
    font-size: 13px !important;
    border-radius: 6px !important;
}

/* Free Listing button small badge */
.navbar .badge {
    font-size: 8px !important;
    padding: 2px 4px !important;
}

/* Logo gap reduce */
.navbar-brand img {
    margin-right: 20px !important;
}

/* Talk to us icon spacing reduce */
.btn i {
    margin-right: 4px !important;
}



            `}</style>

        </>
    );
}

export default Navbar;
